import { createRichTextDocument } from './create'
import { deleteRichTextDocument } from './delete'
import { readRichTextDocument } from './read'
import { resourceObject } from './resourceObject'
import { getCollaborationToken } from './token'
import { updateRichTextDocument } from './update'

export const richTextDocuments = {
  authorize: getCollaborationToken,
  create: createRichTextDocument,
  readSingle: readRichTextDocument,
  update: updateRichTextDocument,
  clientResource: resourceObject,
  delete: deleteRichTextDocument,
}

export type { CreateRichTextDocumentV3RequestBody } from './create'
export type { RichTextDocumentInclude } from './read'
export type { UpdateRichTextDocumentV3RequestBody } from './update'
